module.exports = __webpack_public_path__ + "static/media/landingpagegc.c8fbf565.svg";